import { computeWalletPlanCharge, WalletPlanChargeResult } from './computeWalletPlanCharge';

export interface WalletChargePlanInput {
  availableCents: number;
  /**
   * Invoice cents the wallet is redeeming against. May already include a
   * first-purchase coupon (same ordering as the backend: coupon → wallet
   * plan-tier discount). Callers without a coupon pass the plain catalog.
   */
  invoicePriceCents: number;
  /**
   * Plan-tier wallet discount (10/15/20). Applied only to the wallet-funded
   * share of the invoice; mixed remainder stays full price on the uncovered
   * share of that invoice.
   */
  discountPercent?: number;
}

export function resolveWalletChargePlan({
  availableCents,
  invoicePriceCents,
  discountPercent = 0,
}: WalletChargePlanInput): WalletPlanChargeResult {
  return computeWalletPlanCharge({
    availableCents,
    priceCents: invoicePriceCents,
    discountPercent,
  });
}
